export enum EEducationIcons {
  field = 'field',
  grade = 'grade',
  period = 'period',
  program = 'program',
}
